import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

export function getOrderStateTranslationKey(state: Enums<"orderState">): TranslationKey {
	switch (state) {
		case "pending":
			return "stock.order_state.pending";
		case "complete":
			return "stock.order_state.completed";
		case "open":
			return "stock.order_state.open";
		case "picking":
			return "stock.order_state.picking";
		case "canceled":
			return "stock.order_state.canceled";
		case "in-progress":
			return "stock.order_state.in_progress";
	}
}
